import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Hero from '../components/Hero';
import DailyQuestion from '../components/DailyQuestion';
import RecentNotes from '../components/RecentNotes';
import HowItWorks from '../components/HowItWorks';
import SubjectCategories from '../components/SubjectCategories';
import CommunitySection from '../components/forum/CommunitySection';
import {
  WhatsAppCommunitySection,
  WhatsAppCommunityModal,
} from '../components/community/WhatsAppCommunity';
import { usePageTitle } from '../hooks/usePageTitle';
import { useAuth } from '../contexts/AuthContext';
import { useCommunityLinks } from '../hooks/useCommunityLinks';

const HomePage: React.FC = () => {
  usePageTitle('Ana Sayfa');
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(false);
  const { isLoggedIn } = useAuth();
  const { links } = useCommunityLinks();
  const [waPopup, setWaPopup] = useState(false);

  // Giriş yapan kullanıcıya, topluluk bağlantıları varsa, oturum başına bir kez
  // WhatsApp pop-up'ı göster.
  useEffect(() => {
    if (!isLoggedIn || links.length === 0) return;
    if (sessionStorage.getItem('wa_popup_seen')) return;
    const t = window.setTimeout(() => {
      setWaPopup(true);
      sessionStorage.setItem('wa_popup_seen', '1');
    }, 1600);
    return () => window.clearTimeout(t);
  }, [isLoggedIn, links.length]);

  useEffect(() => {
    const c = () => setIsMobile(window.innerWidth < 768);
    c();
    window.addEventListener('resize', c);
    return () => window.removeEventListener('resize', c);
  }, []);

  useEffect(() => {
    const raw = location.hash.replace(/^#/, '');
    if (!raw) return;
    const t = window.setTimeout(() => {
      document.getElementById(raw)?.scrollIntoView({ behavior: 'smooth' });
    }, 100);
    return () => window.clearTimeout(t);
  }, [location.hash, location.pathname]);

  return (
    <main style={{ position: 'relative', zIndex: 2 }}>
      <Hero />

      <div className="section-divider" style={{ maxWidth: '800px', margin: '0 auto' }} />

      <HowItWorks />

      <div className="section-divider section-divider--cyan" style={{ maxWidth: '800px', margin: '0 auto' }} />

      <SubjectCategories />

      <div className="section-divider" style={{ maxWidth: '800px', margin: '0 auto' }} />

      <div id="notes">
        <RecentNotes />
      </div>

      <div className="section-divider section-divider--amber" style={{ maxWidth: '800px', margin: '0 auto' }} />

      <div id="daily-questions">
        <DailyQuestion />
      </div>

      <div className="section-divider section-divider--cyan" style={{ maxWidth: '800px', margin: '0 auto' }} />

      <CommunitySection isMobile={isMobile} />

      <div className="section-divider section-divider--cyan" style={{ maxWidth: '800px', margin: '0 auto' }} />

      <WhatsAppCommunitySection />

      <WhatsAppCommunityModal open={waPopup} onClose={() => setWaPopup(false)} />
    </main>
  );
};

export default HomePage;
